module.exports = __webpack_public_path__ + "static/e_shop_cover-e7c3f0f53ee7b46105890da539f89782.png";